import React from 'react';
import { Typography, TypographyProps } from '@mui/material';
import styled from '@emotion/styled';

const CustomSubtitle = styled(Typography)(({ theme }: any) => ({
  color: (theme.palette as any).blue?.main || theme.palette.primary.main,
  fontWeight: 400,
  fontSize: '1.4em',
}));

const Subtitle: React.FC<TypographyProps> = (props) => <CustomSubtitle variant="h5" {...props} />;

export default Subtitle;

